// extracted by mini-css-extract-plugin
module.exports = {"burgerIcon":"zE","cross":"zF","iconSVGWrapper":"zG","iconSVG":"zH","iconSVGDark":"zI"};